import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { ApiExError, InsuranceCarrier } from '@shared';

const advisorBgaCarrierSettingsSlice = createSlice({
  name: 'advisorBgaCarrierSettings',
  initialState: initialState.advisorBgaCarrierSettings,
  reducers: {
    fetchAdvisorBgaOrganizationsByAdvisorIdRequest: (
      state,
      action: PayloadAction<{ advisorId: string }>,
    ) => {
      state.bgas.status = 'loading';
    },
    fetchAdvisorBgaOrganizationsByAdvisorIdResponse: (state, action: PayloadAction<BgaEntry[]>) => {
      state.bgas.status = 'complete';
      state.bgas.data = action.payload;
    },
    fetchAdvisorBgaOrganizationsByAdvisorIdFailure: (state, action: PayloadAction<ApiExError>) => {
      state.bgas.status = 'error';
    },
    fetchCarriersByAdvisorIdRequest: (state, action: PayloadAction<{ advisorId: string }>) => {
      state.carriers.status = 'loading';
    },
    fetchCarriersByAdvisorIdResponse: (
      state,
      action: PayloadAction<InsuranceCarrierWithPolicyTypes[]>,
    ) => {
      state.carriers.status = 'complete';
      state.carriers.data = action.payload;
    },
    fetchCarriersByAdvisorIdFailure: (state, action: PayloadAction<ApiExError>) => {
      state.carriers.status = 'error';
    },
    postAdvisorBgaCarrierSettingsByAdvisorIdRequest: (
      state,
      _action: PayloadAction<PostAdvisorBgaCarrierSettingsRequest>,
    ) => {
      state.bgas.status = 'loading';
    },
    postAdvisorBgaCarrierSettingsByAdvisorIdResponse: (
      state,
      action: PayloadAction<PostAdvisorBgaCarrierSettingsResponse>,
    ) => {
      state.bgas.status = 'complete';
      state.bgas.data = action.payload.bgas;
    },
    postAdvisorBgaCarrierSettingsByAdvisorIdFailure: (state, action: PayloadAction<ApiExError>) => {
      state.bgas.status = 'error';
    },
    deleteAdvisorBgaCarrierSettingsByAdvisorIdRequest: (
      state,
      action: PayloadAction<{ advisorId: string; advisorOrganizationId: string }>,
    ) => {
      state.bgas.status = 'loading';
    },
    deleteAdvisorBgaCarrierSettingsByAdvisorIdResponse: (
      state,
      action: PayloadAction<BgaEntry[]>,
    ) => {
      state.bgas.status = 'complete';
      state.bgas.data = action.payload;
    },
    deleteAdvisorBgaCarrierSettingsByAdvisorIdFailure: (
      state,
      action: PayloadAction<ApiExError>,
    ) => {
      state.bgas.status = 'error';
    },
    resetAdvisorBgaCarrierSettings: state => {
      state.bgas.data = [];
      state.bgas.status = null;
    },
    postCarrierSettingsByAdvisorIdRequest: (
      state,
      action: PayloadAction<PostCarrierSettingsByAdvisorIdRequest>,
    ) => {},
    postCarrierSettingsByAdvisorIdResponse: (
      state,
      action: PayloadAction<InsuranceCarrierWithPolicyTypes[]>,
    ) => {
      state.carriers.status = 'complete';
      state.carriers.data = action.payload;
    },
    postCarrierSettingsByAdvisorIdFailure: (state, action: PayloadAction<ApiExError>) => {
      state.carriers.status = 'error';
    },
  },
});

export const {
  fetchCarriersByAdvisorIdRequest,
  fetchCarriersByAdvisorIdResponse,
  fetchCarriersByAdvisorIdFailure,
  deleteAdvisorBgaCarrierSettingsByAdvisorIdRequest,
  deleteAdvisorBgaCarrierSettingsByAdvisorIdResponse,
  deleteAdvisorBgaCarrierSettingsByAdvisorIdFailure,
  postAdvisorBgaCarrierSettingsByAdvisorIdRequest,
  postAdvisorBgaCarrierSettingsByAdvisorIdResponse,
  postAdvisorBgaCarrierSettingsByAdvisorIdFailure,
  fetchAdvisorBgaOrganizationsByAdvisorIdRequest,
  fetchAdvisorBgaOrganizationsByAdvisorIdResponse,
  fetchAdvisorBgaOrganizationsByAdvisorIdFailure,
  resetAdvisorBgaCarrierSettings,
  postCarrierSettingsByAdvisorIdRequest,
  postCarrierSettingsByAdvisorIdResponse,
  postCarrierSettingsByAdvisorIdFailure,
} = advisorBgaCarrierSettingsSlice.actions;

export const advisorBgaCarrierSettingsReducer = advisorBgaCarrierSettingsSlice.reducer;
